import { Box } from '@mui/material';
import { memo } from 'react';

function ArrowPath() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} data-testid="arrowpath">
      {' '}
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.75 3.75V7.65625H4.20431M16.2016 9.21875C15.8172 6.13569 13.1872 3.75 10 3.75C7.37705 3.75 5.13148 5.36576 4.20431 7.65625M4.20431 7.65625H7.65625M16.25 16.25V12.3438H15.7957M15.7957 12.3438C14.8685 14.6342 12.623 16.25 10 16.25C6.8128 16.25 4.18281 13.8643 3.79835 10.7812M15.7957 12.3438H12.3438"
          stroke="#4B5563"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
}

export default memo(ArrowPath);
